__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "openidconnect-provider";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(6215), __webpack_require__.e(7656), __webpack_require__.e(3284)]).then(() => (() => (__webpack_require__(53284))))));
			register("@mui/material", "^7.0.0", () => (Promise.all([__webpack_require__.e(6215), __webpack_require__.e(7518), __webpack_require__.e(424), __webpack_require__.e(7656), __webpack_require__.e(1415), __webpack_require__.e(4561)]).then(() => (() => (__webpack_require__(17518))))));
			register("i18next", "19.9.2", () => (Promise.all([__webpack_require__.e(7200), __webpack_require__.e(408)]).then(() => (() => (__webpack_require__(27200))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(7656)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "11.18.6", () => (Promise.all([__webpack_require__.e(7656), __webpack_require__.e(1530)]).then(() => (() => (__webpack_require__(21530))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(5983), __webpack_require__.e(7656), __webpack_require__.e(6902), __webpack_require__.e(7006)]).then(() => (() => (__webpack_require__(54625))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(5983), __webpack_require__.e(6347), __webpack_require__.e(7656), __webpack_require__.e(8168)]).then(() => (() => (__webpack_require__(56347))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			initExternal(5378);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};